import { render } from "./LoyaltyPoints.vue?vue&type=template&id=88df5086"
import script from "./LoyaltyPoints.vue?vue&type=script&lang=js"
export * from "./LoyaltyPoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__